import { configureStore } from '@reduxjs/toolkit';
import authReducer from './redux/AuthSlice';
import categoryReducer from './redux/CategorySlice';
import productReducer from './redux/ProductSlice';
import customerReducer from './redux/CustomerSlice';
import blogReducer from './redux/BlogSlice';
import orderReducer from './redux/OrderSlice';
import dashboardReducer from './redux/DashboardSlice'




const store = configureStore({
    reducer:{
      auth: authReducer,
      categories: categoryReducer,
      products: productReducer,
      customers:customerReducer,
      blogs: blogReducer,
      orders: orderReducer,
      dashboard: dashboardReducer
    }
})

export default store;